"use client";
import Image from "next/image";
import { useTranslation } from "react-i18next";
import atom from "../assets/images/atom.svg";
import enamad from "../assets/images/enamad.svg";
import english from "../assets/images/english.svg";
import instagram from "../assets/images/instagram.svg";
import linkedin from "../assets/images/linkedin.svg";
import persian from "../assets/images/persian.svg";
import soroushSabzText from "../assets/images/soroushSabzText.svg";
import standard from "../assets/images/standard.svg";
import whatsapp from "../assets/images/whatsapp.svg";
import i18n from "../i18n";
import Link from "next/link";

export default function Footer() {
  const { t, i18n } = useTranslation();

  return (
    <footer className="flex w-full bg-[#003148] text-white py-8 px-52">
      <div className="flex w-full justify-around">
        <div className="flex w-1/3 justify-center">
          <div className="flex w-full md:w-1/3 justify-center gap-5">
            <Image
              src={standard.src}
              alt="standard"
              width={55}
              height={55}
              className="rounded-lg"
            />
            <Image src={atom.src} alt="atom" width={55} height={55} className="rounded-lg" />
            <Image src={enamad.src} alt="enamad" width={55} height={55} className="rounded-lg" />
          </div>
        </div>

        <div className="flex w-1/3 justify-around border-x border-x-[#868686]">
          <div className="flex flex-col gap-5">
            <span>{t("footer.menu")}</span>
            <div className="flex flex-col gap-3">
              <span className="flex items-center gap-2">
                <Dot /> {t("aboutUs")}
              </span>
              <span className="flex items-center gap-2">
                <Dot /> {t("products")}
              </span>
              <span className="flex items-center gap-2">
                <Dot /> {t("services")}
              </span>
              <span className="flex items-center gap-2">
                <Dot /> {t("support")}
              </span>
            </div>
          </div>

          <div className="flex flex-col gap-5">
            <span>{t("footer.media")}</span>
            <div className="flex flex-col gap-3">
              <span className="flex items-center gap-2">
                <Dot /> {t("latestArticles")}
              </span>
              <span className="flex items-center gap-2">
                <Dot /> {t("latestEducation")}
              </span>
              <span className="flex items-center gap-2">
                <Dot /> {t("latestNews")}
              </span>
              <span className="flex items-center gap-2">
                <Dot /> {t("latestPromotion")}
              </span>
            </div>
          </div>

          <div className="flex flex-col gap-5">
            <span>{t("footer.language")}</span>
            <div className="flex flex-col gap-5">
              <span className="flex justify-between gap-2">
                EN
                <Image src={english.src} alt="english" width={30} height={14} />
              </span>
              <span className="flex justify-between gap-2">
                فا
                <Image src={persian.src} alt="persian" width={30} height={14} />
              </span>
            </div>
          </div>
        </div>

        <div className="flex flex-col w-1/3 justify-around items-center">
          <Image
            src={soroushSabzText.src}
            alt="soroush-sabz"
            width={155}
            height={41}
            className="rounded-lg"
          />

          <div className="flex flex-col gap-3">
            <Link className="flex items-center gap-2 justify-right" href="tel:02634019147">
              <Dot />
              {t("footer.phone")} : ۰۲۶-۳۴۰۱۹۱۴۷
            </Link>
            <Link
              className="flex items-center gap-2 justify-right"
              href="mailto:info@soroushsabz.com"
            >
              <Dot />
              {t("footer.email")} : info@soroushsabz.com
            </Link>
          </div>

          <div className="flex gap-5">
            <Image
              src={linkedin.src}
              alt="linkedin"
              width={30}
              height={30}
              className="rounded-lg"
            />
            <Image
              src={whatsapp.src}
              alt="whatsapp"
              width={30}
              height={30}
              className="rounded-lg"
            />
            <Image
              src={instagram.src}
              alt="instagram"
              width={30}
              height={30}
              className="rounded-lg"
            />
          </div>
        </div>
      </div>
    </footer>
  );
}

function Dot() {
  return (
    <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="2.21289" cy="2.21191" r="2" fill="#43CA71" />
    </svg>
  );
}
